import { useFormik } from "formik";
import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FileDisplay from "../../../utils/FileDisplay";
import { NuDate, NuInput, NuTextArea, NuTime, NuUpload } from "../../../utils/Inputs";
import FormikSelectTwo from "../../../utils/Select";
import { handleKeyDown, ScreenClose } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";

export default function CreateOrEdit({
  data,
  visible,
  onClose,
  refreshData,
  satusData = [],
  id,
  getCompletion = () => {},
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [selectedFile, setSelectedFile] = useState([]);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [createNew, setCreateNew] = useState({
    heading: "",
    group_data: "",
    mom_date: "",
    type_of_meeting: null,
    start_time: "",
    end_time: "",
    regrets: "",
    venue: "",
    chaired_by: "",
    minute_by: "",
    assignedToWhom: "",
    item: "",
    targetDate: "",
    status: null,
  });
  useEffect(() => {
    setCreateNew({
      heading: data?.heading,
      group_data: data?.group_data,
      mom_date: data?.mom_date,
      type_of_meeting: data?.type_of_meeting,
      start_time: data?.start_time,
      end_time: data?.end_time,
      regrets: data?.regrets,
      venue: data?.venue,
      chaired_by: data?.chaired_by,
      minute_by: data?.minute_by,
      assignedToWhom: data?.assignedToWhom,
      item: data?.item,
      targetDate: data?.targetDate,
      status: data?.status,
      attachments:data?.attachments,
    })
    if(data?.attachments !==null && data?.attachments !=="None" && data?.attachments !=="[]"){
      setFilePathList(data?.attachments)
      setRemoveFilePathList(data?.attachments)
    }
  }, [data]);

  function handleImageChange(e) {
    const files = Array.from(e.target.files);
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit:  async (value, { resetForm }) => {
      if (data) {
        if(!value.mom_date){
          value.mom_date = "None"
        }
        if(!value.start_time){
          value.start_time = "None"
        }
        if(!value.end_time){
          value.end_time = "None"
        }
        let formData = new FormData();
        if(removefilePathList){
          let finalArr = removefilePathList.filter(items=>  !filePathList.includes(items) )
          value.files_to_remove = finalArr.map(item=>item.replace(window.WEB_APP_API_URL, "localhost"));
        }else{
          value.files_to_remove = []
        }
        if(selectedFile !== null){
          selectedFile.forEach((file) => {
            formData.append("attachment", file);
          });
        }else{
          formData.append("attachment",[])
        } 
  
        formData.append("mom_data", JSON.stringify(value));
        await ScreenClose({ link: "Minute-Of-Meeting", id: data.id });
        await editData({
          url: `/Minute-Of-Meeting/${data.id}/`,
          value: formData,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          hasFile: true,
          setSelectedFile: setSelectedFile,
          otherFunction: getCompletion,
        });
      } else {
        let formdata = new FormData();
        if(selectedFile){
          selectedFile.forEach((file) => {
            formdata.append("attachment", file);
          });
        }else{
          formdata.append("attachment", []);
        }
        formdata.append("mom_data", JSON.stringify(value));
        addData({
          url: `/Minute-Of-Meeting/standard/${id}/`,
          value: formdata,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          otherFunction: getCompletion,
        });
      }
    },
  });
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList !== item);
    setFilePathList(filterList);
  }

  const resetClose = () => {
    if(data){
      ScreenClose({ link: "Minute-Of-Meeting", id: data.id });
    }
    setSelectedFile(null)
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-6/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={resetClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
              <NuInput
                formik={formik}
                name="heading"
                label="Heading"
                width="w-1/2"
                placeholder="Heading"
              />
              <NuInput
                formik={formik}
                name="group_data"
                label="Group"
                width="w-1/2"
                placeholder="Heading"
              />
                <NuDate
                formik={formik}
                name="mom_date"
                label="Date"
                width="w-1/2"
                placeholder="Date"
              />
              <NuInput
                formik={formik}
                name="type_of_meeting"
                label="Type of Meeting"
                width="w-1/2"
                placeholder="Type of Meeting"
              />
              <NuTime
               formik={formik}
               name="start_time"
               label="Start Time"
               width="w-1/2"
               placeholder="Start Time"
              />
              <NuTime
               formik={formik}
               name="end_time"
               label="End Time"
               width="w-1/2"
               placeholder="End Time"
              />
              <NuInput
                formik={formik}
                name="regrets"
                label="Regrets"
                width="w-1/2"
                placeholder="Regrets"
              />
              <NuInput
                formik={formik}
                name="venue"
                label="Venue"
                width="w-1/2"
                placeholder="Venue"
              />
              <NuInput
                formik={formik}
                name="chaired_by"
                label="Chaired By"
                width="w-1/2"
                placeholder="Chaired By"
              />
              <NuInput
                formik={formik}
                name="minute_by"
                label="Minutes By"
                width="w-1/2"
                placeholder="Minutes By"
              />
              <NuUpload
                label="Artefact"
                width="w-1/2"
                onChange={handleImageChange}
                multiple={true}
              />
              <FormikSelectTwo
                formik={formik}
                name="status"
                label="Status"
                width="w-1/2"
                placeholder="Select Status"
                Options={satusData}
                zindex={12}
              />
              <div className=" w-full flex flex-wrap ">
                {data?.attachments &&
                  filePathList.map((i) => {
                    return (
                      <div className=" m-1 my-3">
                        <div className=" relative">
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-bold flex justify-center items-center  -top-2 right-2 z-10"
                            onClick={() => UpdateAttachmentList(i)}
                          >
                            -
                          </div>
                          <FileDisplay
                            data={i}
                            view={true}
                            height={"45px"}
                            width={"45px"}
                          />
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
